import React from "react";
import Line from "./Line";

const Footer = () => {
	return (
		<div className="footer">
			<Line />
			<p>Copyright © 2023 Nitro Network. All rights reserved.</p>
		</div>
	);
};

export default Footer;
